/**
 * MafiaEventLog — Chronological event log with color coding
 *
 * Requirements: 28.1–28.5
 */

import React, { useRef, useEffect } from 'react';
import { GameEvent, EVENT_COLORS } from '../types';
import './MafiaEventLog.css';

export interface MafiaEventLogProps {
  events: GameEvent[];
}

export const MafiaEventLog: React.FC<MafiaEventLogProps> = ({ events }) => {
  const endRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [events.length]);

  const formatTime = (timestamp: number) => {
    const d = new Date(timestamp);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="mafia-event-log" role="log" aria-label="Game Event Log">
      <h3 className="mafia-event-log__title">📜 Event Log</h3>

      {events.length === 0 ? (
        <div className="mafia-event-log__empty">No events yet</div>
      ) : (
        <ul className="mafia-event-log__items" aria-live="polite">
          {events.map((event) => {
            const color = EVENT_COLORS[event.type] || 'gray';
            return (
              <li
                key={event.id}
                className={`mafia-event-log__item mafia-event-log__item--${color}`}
              >
                <span className="mafia-event-log__time">{formatTime(event.timestamp)}</span>
                {event.message}
              </li>
            );
          })}
          <div ref={endRef} />
        </ul>
      )}
    </div>
  );
};

export default MafiaEventLog;
